import { breakpoints, Container } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import * as React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useSiteData } from "../../services/app-state";
import { HeroPage } from "../organisms/HeroPage";

const PageWrapper = styled.div`
    background-color: white;
`;

const Inner = styled.div`
    text-align: center;
    padding: 75px 0;
    ${breakpoints.large} {
        padding: 100px 0;
    }
`;

const ErrorBox = styled.div`
    margin: 0 auto;
    margin-top: 48px;
    max-width: 800px;
    padding: 24px;
    background-color: ${transparentize(0.9, "red")};
    border: 1px solid red;

    > *:last-child {
        margin-bottom: 0;
    }
`;

export const UnexpectedError: React.FC<{ error: Error }> = ({ error }) => {
    const [siteData] = useSiteData();

    return (
        <>
            <Helmet>
                <title>Unexpected Error</title>
            </Helmet>
            <HeroPage title="Unexpected Error" />
            <PageWrapper>
                <Container>
                    <Inner>
                        <h2>Something went wrong while processing that.</h2>
                        <p>
                            Please refresh the page and try again. Alternatively,{" "}
                            <Link to={"/"}>click here</Link> to head to the homepage.
                        </p>
                        {siteData.isAdmin && (
                            <ErrorBox>
                                <p>
                                    <pre>{error.message}</pre>
                                </p>
                                <p style={{ fontSize: 14 }}>
                                    <em>
                                        (Note: this red error block is only shown to logged in
                                        users)
                                    </em>
                                </p>
                            </ErrorBox>
                        )}
                    </Inner>
                </Container>
            </PageWrapper>
        </>
    );
};
